import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@fluentui/react-components";
import { ArrowClockwiseFilled } from "@fluentui/react-icons";
import { useImportedInvoicesStore } from "store/ImportedInvoicesStore";

export const RefreshButton = () => {
  const [{ importedInvoicesLoadStatus }, { loadImportedInvoices }] =
    useImportedInvoicesStore();
  const { t } = useTranslation();

  return (
    <Button
      data-help="imported-invoices-refresh"
      disabled={importedInvoicesLoadStatus === "loading"}
      appearance="subtle"
      icon={<ArrowClockwiseFilled fontSize={24} />}
      onClick={() => {
        loadImportedInvoices({ t });
      }}
    ></Button>
  );
};
